import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import { imageItem, resType } from '../types'
interface IUploadRes {
  message: string
  data: {
    format: string
    height: number
    width: number
    url_list: { url: string }[]
  }
}
// 配置开发url
export async function uploadImg(img: File): Promise<resType<IUploadRes>> {
  const form = new FormData()
  form.append('image', img)
  form.append('aid', '1839')
  form.append('app_name', 'auto_web_pc')

  try {
    const data: IUploadRes = await fetch(
      'https://i.snssdk.com/feedback/image/v1/upload/',
      {
        method: 'POST',
        body: form,
      }
    )
    return {
      success: true,
      data,
    }
  } catch (err) {
    console.log(err)
    return {
      success: false,
      err,
    }
  }
}
interface ISubmitRes {
  message: string
  feddback_id: number
  err_code: number
}
// document.cookie = 'test=' + getCookieProp('tt_webid') + ';domain=https://i-boe.snssdk.com/';
export async function submitFeedback(
  tel: string,
  content: string,
  image_list: imageItem[]
): Promise<resType<ISubmitRes>> {
  const form = new URLSearchParams()
  form.append('aid', '1839')
  form.append('app_name', 'auto_web_pc')
  form.append('appkey', 'auto-web')
  form.append('content', content)
  form.append('contact', tel)
  form.append('iid', '')
  if (image_list.length === 1) {
    form.append('multi_image', '0') //一张图片
    for (const prop in image_list[0]) {
      form.append(prop, `${image_list[0][prop]}`)
    }
  } else if (image_list.length > 1) {
    form.append('multi_image', '1') //多张图片
    form.append('image_list', JSON.stringify(image_list))
  }
  try {
    const tea_cache = localStorage.getItem('__tea_cache_tokens_1839')
    const web_id = tea_cache ? JSON.parse(tea_cache).web_id : ''
    document.cookie = `device_id=${web_id}`
    const data: ISubmitRes = await fetch('/feedback/2/post_message/', {
      // credentials: "include",
      mode: 'cors',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: form,
    })
    document.cookie = 'device_id=; expires=Thu, 01 Jan 1970 00:00:00 GMT' //设置超时时间 自动清除cookie
    return {
      success: true,
      data,
    }
  } catch (err) {
    document.cookie = 'device_id=; expires=Thu, 01 Jan 1970 00:00:00 GMT' //设置超时时间 自动清除cookie
    console.log(err)
    return {
      success: false,
      err,
    }
  }
}
